import { Property } from '@model';
import { parseFloatWithCulture } from '@utils';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const siteContentBaseUrl = import.meta.env.VITE_SITE_CONTENT_BASE_URL;

// Raw shape returned by the API / site-content JSON before culture-aware parsing
type PropertyDto = Omit<
  Property,
  'forSale' | 'price' | 'pricePerSqrm' | 'sqrMeters' | 'updateDate'
> & {
  price: string;
  pricePerSqrm: string;
  sqrMeters: string;
  updateDate: string;
};

const mapPropertyDto = (prop: PropertyDto, culture: string) =>
  ({
    ...prop,
    forSale: prop.aimId == 1,
    price: parseFloatWithCulture(prop.price, culture),
    pricePerSqrm: parseFloatWithCulture(prop.pricePerSqrm, culture),
    sqrMeters: parseFloatWithCulture(prop.sqrMeters, culture),
    updateDate: new Date(prop.updateDate),
  }) as Property;

export const fetchAllPropertiesEarly = async (
  culture: string,
): Promise<Property[]> =>
  await fetch(`${siteContentBaseUrl}/properties-${culture}.json`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res) =>
      res.map((prop: PropertyDto) => mapPropertyDto(prop, culture)),
    );

export const fetchAllProperties = async (
  culture: string,
): Promise<Property[]> =>
  await fetch(`${apiBaseUrl}/properties?culture=${culture}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res) =>
      res.map((prop: PropertyDto) => mapPropertyDto(prop, culture)),
    );
